import { defineComponent as _defineComponent } from 'vue';
import { renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withModifiers as _withModifiers, withCtx as _withCtx, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "modal-content bg-white rounded"
};
const _hoisted_2 = {
  key: 0,
  class: "py-1 text-center text-slate-800 font-semibold"
};
const _hoisted_3 = {
  key: 1,
  class: "-mx-4"
};
const _hoisted_4 = {
  class: "-mx-4"
};
const _hoisted_5 = {
  class: "modal-footer flex justify-between"
};
const _hoisted_6 = {
  key: 0,
  class: "mr-2"
};
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", null, null, -1);
export default /*#__PURE__*/_defineComponent({
  __name: 'Modal',
  setup(__props, {
    expose
  }) {
    const showState = ref(false);
    const show = () => showState.value = true;
    const hide = () => showState.value = false;
    expose({
      show,
      hide
    });
    return (_ctx, _cache) => {
      const _component_NDivider = _resolveComponent("NDivider");
      const _component_Icon = _resolveComponent("Icon");
      const _component_NButton = _resolveComponent("NButton");
      const _component_NModal = _resolveComponent("NModal");
      return _openBlock(), _createBlock(_component_NModal, {
        show: showState.value,
        "onUpdate:show": _cache[0] || (_cache[0] = $event => showState.value = $event),
        preset: "dialog",
        "show-icon": false,
        closable: false,
        "auto-focus": false,
        "trap-focus": "",
        "mask-closable": false,
        "close-on-esc": false,
        "block-scroll": "",
        class: "modal"
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_ctx.$slots.title ? (_openBlock(), _createElementBlock("div", _hoisted_2, [_renderSlot(_ctx.$slots, "title")])) : _createCommentVNode("", true), _ctx.$slots.title ? (_openBlock(), _createElementBlock("div", _hoisted_3, [_createVNode(_component_NDivider)])) : _createCommentVNode("", true), _renderSlot(_ctx.$slots, "default"), _createElementVNode("div", _hoisted_4, [_createVNode(_component_NDivider)]), _createElementVNode("div", _hoisted_5, [_ctx.$slots.footer ? (_openBlock(), _createElementBlock("div", _hoisted_6, [_renderSlot(_ctx.$slots, "footer")])) : _createCommentVNode("", true), _hoisted_7, _createVNode(_component_NButton, {
          secondary: "",
          onClick: _withModifiers(hide, ["stop"])
        }, {
          default: _withCtx(() => [_createVNode(_component_Icon, {
            icon: _ctx.IconEnum.CheckRound
          }, null, 8, ["icon"])]),
          _: 1
        }, 8, ["onClick"])])])]),
        _: 3
      }, 8, ["show"]);
    };
  }
});